import { create } from 'zustand';
import axios from 'axios';

const useProductStore = create((set, get) => ({
    products: [],
    loading: false,
    lastUpdated: null,

    fetchProducts: async () => {
        set({ loading: true });
        try {
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };
            const timestamp = new Date().getTime();

            // Fetch Dolibarr products + used-item stock map in parallel
            const [productsRes, stockMapRes] = await Promise.all([
                axios.get(`/api/products?_t=${timestamp}`, { headers }),
                axios.get('/api/used-items/stock-map', { headers }).catch(() => ({ data: {} })),
            ]);

            const rawProducts = Array.isArray(productsRes.data) ? productsRes.data : [];
            console.log(`[STORE] Raw products count: ${rawProducts.length}`);

            // stockMap: { "dolibarr_product_id": { count: N, ids: [...] } }
            const stockMap = stockMapRes?.data || {};
            console.log(`[STORE] Stock map data keys:`, Object.keys(stockMap).length);

            // Inject used_stock for USED-* products; their Dolibarr stock is always 0
            const products = rawProducts.map(p => {
                if (!p) return null;
                try {
                    const isUsed = typeof p.ref === 'string' && p.ref.startsWith('USED-');
                    if (isUsed) {
                        const pid = String(p.id);
                        const data = stockMap[pid] || { count: 0, ids: [] };
                        return {
                            ...p,
                            stock: data.count || 0,
                            available_ids: Array.isArray(data.ids) ? data.ids : [],
                            is_used: true
                        };
                    }
                    return p;
                } catch (e) {
                    console.error(`[STORE] Error transforming product ${p?.id}:`, e);
                    return p;
                }
            }).filter(p => p !== null);

            // Filter out used products with zero stock
            const visibleProducts = products.filter(p => !p.is_used || (p.stock && p.stock > 0));

            console.log(`[STORE] Final visible products count: ${visibleProducts.length}`);
            set({ products: visibleProducts, loading: false, lastUpdated: new Date() });
            return visibleProducts;
        } catch (error) {
            console.error('Failed to fetch products:', error);
            set({ loading: false });
            return [];
        }
    },

    // Optimistic decrement for POS
    optimisticDecrement: (items) => {
        const { products } = get();
        const updatedProducts = products.map(p => {
            const saleItem = items.find(item => item.id === p.id);
            if (saleItem) {
                const newStock = Math.max(0, p.stock - saleItem.qty);
                const remainingIds = p.is_used ? (p.available_ids || []).slice(saleItem.qty) : (p.available_ids || []);
                return {
                    ...p,
                    stock: newStock,
                    available_ids: remainingIds
                };
            }
            return p;
        }).filter(p => !p.is_used || p.stock > 0);

        set({ products: updatedProducts });
    }
}));

export default useProductStore;
